// @flow

import { createAction } from 'redux-actions';

// largerFont()
// ------------

export type LargerFontActionType = 'ACCESSIBILITY:FONT:LARGER';

export type LargerFontAction = {
  type: LargerFontActionType,
};


export const largerFont: () => LargerFontAction = createAction('ACCESSIBILITY:FONT:LARGER');


// smallerFont()
// ------------

export type SmallerFontActionType = 'ACCESSIBILITY:FONT:SMALLER';

export type SmallerFontAction = {
  type: SmallerFontActionType,
};


export const smallerFont: () => SmallerFontAction = createAction('ACCESSIBILITY:FONT:SMALLER');


// setFontSize()
// ------------

export type SetFontSizeActionType = 'ACCESSIBILITY:FONT:SET_SIZE';

export type SetFontSizeActionArgs = {|
  fontSize: number,
|};

export type SetFontSizeAction = {
  type: SetFontSizeActionType,
  payload: {
    fontSize: $PropertyType<SetFontSizeActionArgs, 'fontSize'>,
  },
};


export const setFontSize: (SetFontSizeActionArgs) => SetFontSizeAction = createAction('ACCESSIBILITY:FONT:SET_SIZE');


// resetFont()
// ------------

export type ResetFontActionType = 'ACCESSIBILITY:FONT:RESET';

export type ResetFontAction = {
  type: ResetFontActionType,
};


export const resetFont: () => ResetFontAction = createAction('ACCESSIBILITY:FONT:RESET');



// WEBPACK FOOTER //
// ./src/modules/accessibility/store/actions/accessibility.js